import React, { useEffect } from 'react';
import { config } from '../../utility/AppConfig';
import { addScriptToHead } from '../../utility/utility';
export const Recaptcha = (props) => {
    useEffect(() => {
        addScriptToHead(`https://www.google.com/recaptcha/api.js?render=${config.RECAPTCHA_SITE_KEY}`);
      }, []);
    const handleClick = (event) => {
        // Validate recaptcha
        const grecaptcha = window.grecaptcha;
        grecaptcha?.ready(function () {
            grecaptcha.execute(config.RECAPTCHA_SITE_KEY, { action: 'submit' }).then(function (token) {
                if (props.children.props.onClick) {
                    props.children.props.onClick(event,token);
                }
            });
        });
        // Call the child component's onClick handler
       
    };

    return React.cloneElement(props.children, { onClick: handleClick });
}